// extracted by mini-css-extract-plugin
export var link = "ErrorBoundary-module--link--79a48";
export var message = "ErrorBoundary-module--message--98f94";